export default {
  createMealSchedules: 'CREATE_MEAL_SCHEDULES',
  createMealSchedulesSuccess: 'CREATE_MEAL_SCHEDULES_SUCCESS',
  createMealSchedulesFailed: 'CREATE_MEAL_SCHEDULES_FAILED',
  toggleCreateScheduleModal: 'CREATE_MEAL_SCHEDULES_MODAL',
};
